import rootSaga from './root';

const reducers = {
};

export { rootSaga as default, reducers };
